import * as type from './mutation-types'
const mutations = {
  // 首页tips
  // 初始化
  [type.INIT](state, openLits) {
    const stor = JSON.stringify(state)
    if (openLits.url === 'home') {
      state.openLits[0] = openLits
    } else {
      stor.indexOf(openLits.name) === -1 && state.openLits.push(openLits)
    }
    sessionStorage.setItem('tips', JSON.stringify(state.openLits))
  },
  // 添加tips
  [type.OPENLIST](state, openLits) {
    const stor = JSON.stringify(state)
    stor.indexOf(openLits.name) === -1 &&
    openLits.name !== '首页' &&
    state.openLits.push(openLits)
    state.openLits.forEach((item, index, arr) => {
      item.url === openLits.url
        ? (item.selected = true)
        : (item.selected = false)
    })
    sessionStorage.setItem('tips', JSON.stringify(state.openLits))
  },
  // 删除tips
  [type.DELLIST](state, index) {
    // 数组的长度
    let len = state.openLits.length
    if (index < len - 1 && state.openLits[index].selected) {
      state.openLits[index + 1].selected = true
      state.openLits.splice(index, 1)
    } else if (
      index === len - 1 &&
      index !== 0 &&
      state.openLits[index].selected
    ) {
      state.openLits[index - 1].selected = true
      state.openLits.splice(index, 1)
    } else if (index === 0) {
      state.openLits.splice(index, 1)
    } else if (index < len - 1 && !state.openLits[index].selected) {
      state.openLits.splice(index, 1)
    } else if (
      index === len - 1 &&
      index !== 0 &&
      !state.openLits[index].selected
    ) {
      state.openLits.splice(index, 1)
    }
    sessionStorage.setItem('tips', JSON.stringify(state.openLits))
  },
  // 改变当前选中的tips
  [type.CHANGE](state, index) {
    state.openLits.map((item, ind) => {
      if (ind === index) {
        item.selected = true
      } else {
        item.selected = false
      }
    })
    sessionStorage.setItem('tips', JSON.stringify(state.openLits))
  },
  // 清空tips
  [type.CLEAR](state) {
    state.openLits = [
      {
        name: '专家审核',
        selected: true,
        url: 'zjxx'
      }
    ]
  },
  // 规划咨询模块弹出
  [type.changeproposal](state) {
    state.proposalLayer = false
  },
  [type.changestudy](state) {
    state.studyLayer = false
  },
  [type.changeplan](state) {
    state.planLayer = false
  },
  // 投资管理弹出
  [type.changetouzi](state) {
    state.touziLayer = false
  },
  // 是否项目组成员
  [type.changeayth](state, or) {
    state.ayth = or
  },

  getPidOptions(state, arr) {
    state.pidOptions = arr
  },
  tabsActiveFn(state, urlItem){
    state.urlItem = urlItem
    console.log(urlItem)
    sessionStorage.setItem('urlItem', JSON.stringify(urlItem))
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js